import { render, staticRenderFns } from "./chemComponents.vue?vue&type=template&id=53844c94&scoped=true"
import script from "./chemComponents.vue?vue&type=script&lang=js"
export * from "./chemComponents.vue?vue&type=script&lang=js"
import style0 from "./chemComponents.vue?vue&type=style&index=0&id=53844c94&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53844c94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53844c94')) {
      api.createRecord('53844c94', component.options)
    } else {
      api.reload('53844c94', component.options)
    }
    module.hot.accept("./chemComponents.vue?vue&type=template&id=53844c94&scoped=true", function () {
      api.rerender('53844c94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/chemComponents.vue"
export default component.exports